import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { SuperAdminService } from "../../../super-admin.service";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import { debounce } from "lodash";
import { ActivatedRoute } from "@angular/router";
import * as XLSX from "xlsx";

@Component({
  selector: "app-vechile-list",
  templateUrl: "./vechile-list.component.html",
  styleUrls: ["./vechile-list.component.css"],
})
export class VechileListComponent implements OnInit {
  private debouncedSearch: () => void;
  transporterId: string | null = null;
  isTransporterView: boolean = false;
  users: any = [];
  page: number = 1;
  limit: number = 10;
  totalRecords: number = 0;
  userSessionData: any;
  isAdmin: boolean = false;
  isSuperSupervisor: boolean = false;
  searchText: string = "";
  filters = {
    fromDate: null,
    toDate: null,
  };
  @ViewChild("paginator") paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  displayedColumns: any = [
    "vehicle_no",
    "type",
    "addedBy",
    "transporterName",
    "policyNumber",
    "roadTaxDate",
    "insuranceDueDate",
    "fitnessDueDate",
    "action",
  ];
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private spinner: NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    this.userSessionData = JSON.parse(sessionStorage.getItem("userSession"));
    if (this.userSessionData?.user_role_id?.[0] === 1) {
      this.isAdmin = true;
    } else if (this.userSessionData?.user_role_id?.includes(7)) {
      this.isSuperSupervisor = true;
    }

    this.transporterId = this.route.snapshot.paramMap.get("transporterId");
    this.isTransporterView = !!this.transporterId;

    if (this.isTransporterView) {
      this.displayedColumns = this.displayedColumns.filter(
        (col) => col !== "action",
      );
    }

    this.debouncedSearch = debounce(() => {
      this.page = 1;
      this.getVehicle();
    }, 300);

    this.getVehicle();
  }

  getVehicle() {
    this.spinner.show();

    const params: any = {
      page: this.page,
      limit: this.limit,
    };

    if (this.searchText?.trim()) {
      params.search = this.searchText.trim();
    }
    if (this.filters.fromDate) params.fromDate = this.filters.fromDate;
    if (this.filters.toDate) params.toDate = this.filters.toDate;

    const apis =
      this.isTransporterView && this.transporterId
        ? this.superAdminService.getVehiclesOfTransporter(this.transporterId)
        : this.superAdminService.getVehicleFiltered(params);

    apis.subscribe(
      (res: any) => {
        this.spinner.hide();

        if (res.status) {
          this.users = res.data;
          this.totalRecords = res.pagination?.totalRecords || res.data.length;

          this.dataSource = new MatTableDataSource(this.users);
          this.dataSource.sort = this.sort;
        } else {
          this.toastr.error(res.message);
        }
      },
      () => {
        this.spinner.hide();
        this.toastr.error("Something went wrong! Please contact us");
      },
    );
  }

  onPageChange(event: any) {
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;
    this.getVehicle();
  }

  applyFilter() {
    this.page = 1;
    this.debouncedSearch();
  }

  clearFilter() {
    this.filters.fromDate = null;
    this.filters.toDate = null;
    this.page = 1;
    this.getVehicle();
  }

  // emitdata(params) {
  //   sessionStorage.setItem("userdata", JSON.stringify(params));
  // }

  deleteuser(_id) {
    if (this.superAdminService.deleteDailogBox()) {
      this.superAdminService.deleteVehicle(_id).subscribe(
        (res: { status: any; message: any; authorization: any; code: any }) => {
          if (res.status == true) {
            this.toastr.success(res.message);
            //this.router.navigateByUrl('/user/userManagement');
            this.getVehicle();
          } else {
            if (res.status == 401) {
              this.toastr.error(res.message);
              window.sessionStorage.clear();
              this.router.navigateByUrl("superAuth/login");
            } else {
              this.toastr.error(res.message);
            }
          }
        },
        (error) => {},
      );
    }
  }

  sortData(sort: Sort) {
    const data = this.dataSource.filteredData;
    if (!sort.active || sort.direction === "") {
      return this.dataSource;
    }
    this.dataSource.filteredData = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "ownerName":
          return compare(lower(a.ownerName), lower(b.ownerName), isAsc);
        case "roadTaxDate":
          return compare(a.roadTaxDate, b.roadTaxDate, isAsc);
        case "insuranceDueDate":
          return compare(a.insuranceDueDate, b.insuranceDueDate, isAsc);
        case "CGSTNumber":
          return compare(a.fitnessDueDate, b.fitnessDueDate, isAsc);
        default:
          return 0;
      }
    });
    function compare(a: number | string, b: number | string, isAsc: boolean) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
    function lower(value) {
      return value ? value.toLowerCase() : value;
    }
  }

  onDateChange(event: any, type: "from" | "to") {
    const value = event.target.value || null;

    if (type === "from") {
      this.filters.fromDate = value;
    } else {
      this.filters.toDate = value;
    }

    this.page = 1;
    this.getVehicle();
  }

  clearFilters() {
    this.filters.fromDate = null;
    this.filters.toDate = null;
    this.searchText = "";
    this.page = 1;
    this.getVehicle();
  }

  exportToExcel() {
    this.spinner.show();

    // Use current search text if available
    const search =
      this.dataSource && this.dataSource.filter ? this.dataSource.filter : "";

    const fromDate = "";
    const toDate = "";

    this.superAdminService.exportVehicles(search, fromDate, toDate).subscribe(
      (res: any) => {
        this.spinner.hide();

        if (!res.status || !res.rawdata || res.rawdata.length === 0) {
          this.toastr.warning("No vehicles data available to export");
          return;
        }

        // Convert JSON → Worksheet
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(res.rawdata);

        // Create Workbook
        const workbook: XLSX.WorkBook = {
          Sheets: { Vehicles: worksheet },
          SheetNames: ["Vehicles"],
        };

        // File name
        const fileName = `Vehicles_Data_${new Date()
          .toISOString()
          .slice(0, 10)}.xlsx`;

        // Download Excel
        XLSX.writeFile(workbook, fileName);

        this.toastr.success("Vehicles exported successfully");
      },
      (error) => {
        this.spinner.hide();
        this.toastr.error("Failed to export vehicles");
      },
    );
  }
}
